/**
 * Validates phone numbers for signup / profile flows.
 * Accepts common formatting; validates on digit count.
 */
export const getPhoneValidationError = (phone: string): string | null => {
  const trimmed = phone.trim();
  if (!trimmed) {
    return "Please enter your phone number";
  }

  const digits = trimmed.replace(/\D/g, "");

  if (digits.length < 10) {
    return "Phone number must be at least 10 digits";
  }

  if (digits.length > 13) {
    return "Phone number must be at most 13 digits";
  }

  return null;
};

export const isPhoneValid = (phone: string): boolean =>
  !getPhoneValidationError(phone);
